import save from '../images/SupportUkraineCompanies/save-children.png';
import save2x from '../images/SupportUkraineCompanies/save-children-2x.png';
import hope from '../images/SupportUkraineCompanies/hope.png';
import hope2x from '../images/SupportUkraineCompanies/hope-2x.png';
import united from '../images/SupportUkraineCompanies/united24.png';
import united2x from '../images/SupportUkraineCompanies/united24-2x.png';
import corps from '../images/SupportUkraineCompanies/med-corps.png';
import corps2x from '../images/SupportUkraineCompanies/med-corps-2x.png';
import medsans from '../images/SupportUkraineCompanies/msf.png';
import medsans2x from '../images/SupportUkraineCompanies/msf-2x.png';
import razom from '../images/SupportUkraineCompanies/razom.png';
import razom2x from '../images/SupportUkraineCompanies/razom-2x.png';
import action from '../images/SupportUkraineCompanies/aah.png';
import action2x from '../images/SupportUkraineCompanies/aah-2x.png';
import world from '../images/SupportUkraineCompanies/word-vision.png';
import world2x from '../images/SupportUkraineCompanies/word-vision-2x.png';
import prytula from '../images/SupportUkraineCompanies/prytula.png';
import prytula2x from '../images/SupportUkraineCompanies/prytula-2x.png';

export const supportCompanies = 
  [
    {
      title: 'Save the Children',
      url: 'https://www.savethechildren.net/what-we-do/emergencies/ukraine-crisis ',
      img: save,
      img2: save2x,
    },
    {
      title: 'Project HOPE',
      url: 'https://www.projecthope.org/country/ukraine/ ',
      img: hope,
      img2: hope2x,
    },
    {
      title: 'UNITED24',
      url: 'https://u24.gov.ua/uk ',
      img: united,
      img2: united2x,
    },
    {
      title: 'International Medical Corps',
      url: 'https://internationalmedicalcorps.org/country/ukraine/ ',
      img: corps,
      img2: corps2x,
    },
    {
      title: 'Medicins Sans Frontieres',
      url: 'https://www.msf.org/ukraine ',
      img: medsans,
      img2: medsans2x,
    },
    {
      title: 'RAZOM',
      url: 'https://www.razomforukraine.org/ ',
      img: razom,
      img2: razom2x,
    },
    {
      title: 'Action against hunger',
      url: 'https://www.actionagainsthunger.org/location/europe/ukraine/ ',
      img: action,
      img2: action2x,
    },
    {
      title: 'World vision',
      url: 'https://www.wvi.org/emergencies/ukraine ',
      img: world,
      img2: world2x,
    },
    {
      title: 'Serhiy Prytula Charity Foundation',
      url: 'https://prytulafoundation.org/en ',
      img: prytula,
      img2: prytula2x,
    },
  ];

